import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import BeaconChat from './views/BeaconChat'
import BeaconResources from './views/BeaconResources'
import BeaconTasks from './views/BeaconTasks'
import BeaconArchitectures from './views/BeaconArchitectures'
import BeaconVpc from './views/BeaconVpc'
import BeaconRecommendations from './views/BeaconRecommendations'
import BeaconApprovals from './views/BeaconApprovals'
import BeaconAdmin from './views/BeaconAdmin'
import BeaconHowTo from './views/BeaconHowTo'
import { Settings } from './views/Settings'
import { Login } from './views/Login'
import { SignUp } from './views/SignUp'
import { ForgotPassword } from './views/ForgotPassword'
import { UserManagement } from './views/UserManagement'
import MarketplaceRegister from './views/MarketplaceRegister'
import SSOComplete from './views/SSOComplete'
import { ToastProvider } from './components/Toast'

function App() {
  return (
    <ToastProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* AWS Marketplace registration — public, customer arrives with token */}
        <Route path="/marketplace/register" element={<MarketplaceRegister />} />
        {/* SSO callback landing — reads token from URL fragment */}
        <Route path="/sso/complete" element={<SSOComplete />} />

        {/* Beacon home = chat */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconChat />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/resources"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconResources />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/tasks"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconTasks />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/architectures"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconArchitectures />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/vpc"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconVpc />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/recommendations"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconRecommendations />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/approvals"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconApprovals />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/admin"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconAdmin />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/beacon/howto"
          element={
            <ProtectedRoute>
              <Layout>
                <BeaconHowTo />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Settings + admin users (Beacon shell); Marketplace SaaS paths stay public above */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout>
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
  )
}

export default App
